import React from 'react';
import { IconLabel } from '@/Componentes';

export const Matricula = ({ value, iconEnabled = true }) => {
	return (
		<IconLabel
			icon={<i className='fas fa-user-check' alt="suap icon" height={15} />}
			iconEnabled={iconEnabled}
			label={value}
			link={`https://suap.ifbaiano.edu.br/edu/aluno/${value}`}
		/>
	);
};

export default Matricula;
